import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AppointmentModel } from './appointment.model';

const LIST_ENDPOINT = '/api/v2/appointments';

@Injectable({ providedIn: 'root' })
export class AgendaProService {
  private baseUrl = environment.apiUrl + LIST_ENDPOINT;

  constructor(private http: HttpClient) {}

  getAppointments(): Promise<AppointmentModel[]> {
    return firstValueFrom(this.http.get<any>(this.baseUrl))
      .then(res => res && res.data ? res.data as AppointmentModel[] : []);
  }

  createAppointment(appointment: AppointmentModel): Promise<AppointmentModel> {
    return firstValueFrom(this.http.post<any>(this.baseUrl, appointment))
      .then(res => res && res.data ? res.data as AppointmentModel : null);
  }

  updateAppointment(id: number, appointment: AppointmentModel): Promise<AppointmentModel> {
    return firstValueFrom(this.http.put<any>(`${this.baseUrl}/${id}`, appointment))
      .then(res => res && res.data ? res.data as AppointmentModel : null);
  }

  deleteAppointment(id: number): Promise<boolean> {
    return firstValueFrom(this.http.delete<any>(`${this.baseUrl}/${id}`))
      .then(res => res && res.success);
  }
}